export default __webpack_public_path__ + "static/media/bugsnag.69ce83c8.svg";